export default "__VITE_ASSET__CnD4vNeG__"